import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${comic.title} - 漫画免费韩漫`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {comic.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
            HOT
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
            NEW
          </span>
        )}
        {comic.isHot && comic.isNew && (
          <>
            <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">HOT</span>
            <span className="absolute top-2 left-14 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">NEW</span>
          </>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-background-50 text-xs line-clamp-2">{comic.description}</p>
        </div>

        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-accent-400 text-xs"></i>
          <span className="text-background-50 text-xs font-medium">{comic.rating}</span>
        </div>
      </div>

      <div className="mt-3">
        <h3 className="text-sm font-semibold text-foreground-800 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-400">{comic.author}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{comic.category}</span>
        </div>
        <div className="flex items-center gap-2 mt-1">
          <span className={`text-xs font-medium ${comic.status === '连载中' ? 'text-primary-500' : 'text-secondary-500'}`}>
            {comic.status}
          </span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{comic.views}阅读</span>
        </div>
      </div>
    </Link>
  );
}